module.exports = __webpack_public_path__ + "85367066.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/Pediatria/24577.jpg
// module id = 1329
// module chunks = 0 1